import { render, staticRenderFns } from "./DashboardNavigation.vue?vue&type=template&id=33d2c610&"
import script from "./DashboardNavigation.vue?vue&type=script&lang=js&"
export * from "./DashboardNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports